import React, { useRef, useState, useEffect } from "react";
import { idealTextColor } from "../../functions";
const FUllImageUpload = ({
  onChangeContent,
  hex = "#000",
  currentImage = null,
  setDimension,
}) => {
  const [content, setContent] = useState(null);
  const [imgViewable, setImageViewable] = useState(null);
  const imageButton = useRef();
  useEffect(() => {
    if (content) onChangeContent(content);
  }, [content]);
  useEffect(() => {
    if (currentImage) {
      var img = new Image();
      img.onload = function () {
        if (setDimension) {
          setDimension({ width: this.width, height: this.height });
        }
      };
      img.src = currentImage;
      setImageViewable(currentImage);
    }
  }, [currentImage]);
  const selectFile = (e) => {
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      var img = new Image();
      img.onload = function () {
        if (setDimension) {
          setDimension({ width: this.width, height: this.height });
        }
      };
      img.src = URL.createObjectURL(content);
      setImageViewable(URL.createObjectURL(content));
      setContent(content);
    }
  };
  return (
    <React.Fragment>
      <div className="col-12">
        <label htmlFor="image" style={{ fontWeight: 100 }}>
          Upload an Image or gif
        </label>
        <input
          ref={imageButton}
          type="file"
          id="image"
          name="image"
          accept={"image/jpeg, image/png, image/gif"}
          className="form-control-file"
          style={{ display: "none" }}
          onChange={selectFile}
        />
        <button
          className="btn btn-white btn-brand-hex ml-2"
          onClick={() => imageButton.current.click()}
          style={{
            "--hover-color": hex,
            "--hover-text-color": hex ? idealTextColor(hex) : "black",
          }}
        >
          Upload
        </button>
      </div>
      <div>
        {imgViewable && (
          <div className="mt-3">
            <img
              src={imgViewable}
              alt="post_img"
              className="w-100"
              style={{
                maxHeight: "100px",
                objectFit: "contain",
              }}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default FUllImageUpload;



// WEBPACK FOOTER //
// ./src/components/ContentUpload/FullImageUpload.js